// extracted by mini-css-extract-plugin
export default {"container":"projections_container__2eb8f","title":"projections_title__38cGL","events":"projections_events__3BDEX"};